import { appRoutePath, isManageWorkspacePath } from "./platform-navigation.js";
import { workspaceRestPath } from "./workspace-url.js";

export const MANAGE_PRIMARY_TABS = [
	"overview",
	"access",
	"domains",
	"billing",
	"integration",
	"activity",
	"email",
	"phone",
	"team",
] as const;

export type ManagePrimaryTabId = (typeof MANAGE_PRIMARY_TABS)[number];

export const MANAGE_PRIMARY_LABEL: Record<ManagePrimaryTabId, string> = {
	overview: "Overview",
	access: "Access",
	domains: "Domains",
	billing: "Billing",
	integration: "Integration",
	activity: "Activity logs",
	email: "Email",
	phone: "Phone",
	team: "Team",
};

export const MANAGE_EMAIL_TABS = ["mailboxes", "aliases", "forwarders", "migration"] as const;
export type ManageEmailTabId = (typeof MANAGE_EMAIL_TABS)[number];

export const MANAGE_EMAIL_LABEL: Record<ManageEmailTabId, string> = {
	mailboxes: "Mailboxes",
	aliases: "Aliases",
	forwarders: "Forwarders",
	migration: "Migration",
};

export const MANAGE_PHONE_TABS = [
	"duty",
	"numbers",
	"routing",
	"status",
	"audit",
	"notifications",
] as const;
export type ManagePhoneTabId = (typeof MANAGE_PHONE_TABS)[number];

export const MANAGE_PHONE_LABEL: Record<ManagePhoneTabId, string> = {
	duty: "Duty & Availability",
	numbers: "Numbers",
	routing: "Call Routing",
	status: "System Status",
	audit: "Audit Log",
	notifications: "Platform Notifications",
};

function manageRestPath(pathname: string): string {
	const rest = workspaceRestPath(appRoutePath(pathname));
	if (!isManageWorkspacePath(pathname)) return "";
	return rest === "/manage" ? "" : rest.slice("/manage/".length);
}

export function managePrimaryTabId(pathname: string): ManagePrimaryTabId | null {
	const sub = manageRestPath(pathname);
	if (sub === "") return "overview";
	if (sub === "access") return "access";
	if (sub.startsWith("domains")) return "domains";
	if (sub === "billing") return "billing";
	if (sub === "integration") return "integration";
	if (sub === "activity") return "activity";
	if (sub.startsWith("email")) return "email";
	if (sub.startsWith("phone")) return "phone";
	if (sub === "team" || sub.startsWith("team/")) return "team";
	return null;
}

export function manageEmailTabId(pathname: string): ManageEmailTabId {
	const sub = manageRestPath(pathname);
	if (!sub.startsWith("email")) return "mailboxes";
	const emailRest = sub.slice("email/".length);
	if (emailRest.startsWith("aliases")) return "aliases";
	if (emailRest.startsWith("forwarders")) return "forwarders";
	if (emailRest.startsWith("migration")) return "migration";
	return "mailboxes";
}

export function managePhoneTabId(pathname: string): ManagePhoneTabId {
	const sub = manageRestPath(pathname);
	if (!sub.startsWith("phone")) return "numbers";
	const phoneRest = sub.slice("phone/".length);
	const segment = phoneRest.split("/")[0] ?? "numbers";
	if ((MANAGE_PHONE_TABS as readonly string[]).includes(segment)) {
		return segment as ManagePhoneTabId;
	}
	return "numbers";
}
